import type { ComponentType } from 'react'
import React from 'react'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type { CompProps, Experiments } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol } from '@wix/thunderbolt-symbols'

const isCsr = !!process.env.browser

let useControllerHook: (
	displayedId: string,
	compType: string,
	_compProps: CompProps,
	compId: string
) => {
	[x: string]: any
}
;(async () => {
	isCsr && (await window.externalsRegistry.react.loaded)
	useControllerHook = require('./hooks').useControllerHook
})()

// Helper to check if className already contains the component ID
function containsId(className: string, id: string): boolean {
	return !!className && new RegExp(`(^|\\s)${id}(\\s|$)`).test(className)
}

export const RunControllersWrapper = withDependencies([ExperimentsSymbol], (experiments: Experiments) => {
	const addIdAsClassName = experiments['specs.thunderbolt.addIdAsClassName']

	return {
		wrapComponent: (Component: ComponentType<any>) => {
			const Wrapper = ({
				compProps: storeProps,
				...restProps
			}: {
				compProps: any
				compId: string
				compClassType: string
				id: string
			}) => {
				const { id: displayedId, compId, compClassType } = restProps
				const compProps = useControllerHook(displayedId, compClassType, storeProps, compId)

				const props = {
					...compProps,
					...restProps,
				} as { [x: string]: any }

				const classNameId = addIdAsClassName ? displayedId : compId

				// Add classNameId to className for dual-mode selectors (ID + class)
				// Skip if already present (StructureComponent adds it in SSR when experiment is on)
				// Check all positions: start, middle, end (no array allocation, just string checks)
				const existingClassName = compProps?.className ?? ''

				const className = containsId(existingClassName, classNameId)
					? existingClassName
					: existingClassName
						? `${existingClassName} ${classNameId}`
						: classNameId

				return <Component {...props} className={className} />
			}
			return Wrapper
		},
	}
})
